import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function PrivateRoute({ children, adminOnly = false }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-slate-400">
        Checking session...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // ✅ Check if route is admin-only
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" />; // kick regular users away
  }

  return children;
}
